import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Modal, makeStyles } from "@material-ui/core"
import { Button, Stack } from "bossfotos-design-system"
import RevolutCheckout from "@revolut/checkout"
import { CircularProgress } from "@material-ui/core"
import { green } from "@material-ui/core/colors"

import { amountInCents } from "../v2_actions/math_utils"
import { revolutTrolley } from "../v2_actions/revolut_trolley"
import { trolleyProcessPayment } from "../v2_actions/trolley_process_payment"

import { sentryApi } from "./o11y/sentryApi"


export const RevolutPayment = ({
  onClose,
  totalPriceOwingByCustomer,
  galleryCurrencyCode,
  trolleyId,
  lastName,
  email,
  setOpenSnackBar,
  onMessage,
  setDisableCheckoutButton,
  onPaymentSuccessfulAndConfirmed,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const publicId = useRef(null)
  const paymentAmount = amountInCents(totalPriceOwingByCustomer)
  const currencyCode = galleryCurrencyCode.toUpperCase()
  const revolutMode = window.LOCAL_SETTINGS.REVOLUT_MODE

  useEffect(() => {
    setLoading(true)
    const target = document.getElementById("payment-request")
    const publicToken = window.LOCAL_SETTINGS.REVOLUT_PUBLIC_KEY
    
    const { paymentRequest } = RevolutCheckout.payments({
      locale: "en",
      publicToken: publicToken,
      mode: revolutMode,
    }).then((paymentInstance) => {
      const paymentRequest = paymentInstance.paymentRequest

      const paymentRequestInstance = paymentRequest(target, {
        currency: currencyCode,
        amount: paymentAmount,
        createOrder: () => {

          return dispatch(revolutTrolley.prepareOrder({
            trolley_id: trolleyId,
            total_price: paymentAmount,
          })).then((order) => {
            publicId.current = order.public_id
            return {
              publicId: order.public_id,
            }
          })
        },
        onSuccess: () => onPaymentSuccess(),
        onError: (message) => onPaymentError(message),
      })

      paymentRequestInstance.canMakePayment().then((method) => {
        if (method) {
          paymentRequestInstance.render()
        } else {
          paymentRequestInstance.destroy()
        }
      }).finally(() => {
        setLoading(false)
      })
    }).catch((error) => {
      onGeneralError(error)
    })
  },[])

  const handlePayWithCard = () => {
    setLoading(true)
    dispatch(revolutTrolley.prepareOrder({
      trolley_id: trolleyId,
      total_price: paymentAmount,
    })).then((order) => {
      publicId.current = order.public_id
      
      RevolutCheckout(order.public_id, revolutMode).then((checkoutInstance) => {
        checkoutInstance.payWithPopup({
          name: lastName,
          email: email,
          onSuccess: () => onPaymentSuccess(),
          onError: (message) => onPaymentError(message),
          onCancel: () => onPaymentCancel(),
        })
      })
    }).catch((error) => {
      onGeneralError(error)
    })
  }

  const onPaymentSuccess = () => {
    dispatch(trolleyProcessPayment.pay({
      trolley_id: trolleyId,
      gateway_payment_ref: publicId.current,
      total_price_paid_by_customer: totalPriceOwingByCustomer,
    })).then(onPaymentSuccessfulAndConfirmed)
    onClose()
    setLoading(false)
  }

  const onPaymentError = (message) => {
    setOpenSnackBar(true)
    console.error(message)
    sentryApi.error("revolut_checkout_error_response", message)
    onMessage("The payment processing failed")
    setDisableCheckoutButton(false)
    onClose()
    setLoading(false)
  }

  const onPaymentCancel = () => {
    setOpenSnackBar(true)
    onMessage("Payment cancelled!")
    setDisableCheckoutButton(false)
    onClose()
    setLoading(false)
  }

  const onGeneralError = (error) => {
    console.error(error)
    sentryApi.error("revolut_checkout_error", error)
    setOpenSnackBar(true)
    onMessage("Payment preparation failed")
    setDisableCheckoutButton(false)
    onClose()
    setLoading(false)
  }
  
  return (
    <Modal
      open={true}
      onClose={onClose}
      disableEnforceFocus
      disableAutoFocus
      disablePortal
    >
      <div className={classes.modal}>
        <Stack alignItems="center">
          { loading ? (
            <CircularProgress
              style={{
                width: 60,
                height: 60,
                color: green[500],
                zIndex: 999,
              }}
            />
          ) : (
            <div style={{ height: "40px", width: "300px"}}>
              <Button
                onClick={handlePayWithCard}
                style={{ width: "300px" }}
              >
                Pay with Card
              </Button>
            </div>
          )}
          <div style={{ height: "50px", width: "300px" }} id="payment-request"></div>
        </Stack>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles({
  modal: {
    position: "relative",
    padding: "20px",
    maxWidth: "360px",
    height: "160px",
    top: "50%",
    left: "50%",
    background: "white",
    transform: "translate(-50%, -50%)",
  },
})
